(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dentuv-tablet-bundles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dentuv-tablet-bundles')) customElements.define('dentuv-tablet-bundles',class extends HTMLElement {
  connectedCallback(){
    if(this.initialized)return;
    this.initialized=true;
    this.sticky=this.sticky||this.querySelector('.dentuv-bundles__sticky');
    if(!this.sticky)return;
    document.body.append(this.sticky);
    this.abortController=new AbortController();
    this.addEventListener('change',()=>this.update(),{signal:this.abortController.signal});
    this.sticky.querySelector('button').addEventListener('click',()=>{
      const button=this.querySelector('[data-bundle-panel]:not([hidden]) button[type="submit"]');
      if(button&&!button.disabled)button.click();
    },{signal:this.abortController.signal});
    this.update();
    this.observer=new IntersectionObserver(entries=>{
      const entry=entries[0];
      this.sticky.hidden=entry.isIntersecting||entry.boundingClientRect.bottom>0;
    });
    this.observer.observe(this.querySelector('.dentuv-bundles__forms'));
  }
  update(){
    const choice=this.querySelector('input:checked');
    const stickyButton=this.sticky.querySelector('button');
    stickyButton.disabled=!choice||choice.disabled;
    stickyButton.textContent=stickyButton.disabled?'Tijdelijk uitverkocht':'Toevoegen in winkelmand';
    if(!choice)return;
    this.querySelectorAll('[data-bundle-panel]').forEach(panel=>panel.hidden=panel.dataset.bundlePanel!==choice.value);
    document.querySelectorAll('[data-tablet-price]').forEach(el=>el.textContent=choice.dataset.price);
    document.querySelectorAll('[data-tablet-compare]').forEach(el=>{el.textContent=choice.dataset.compare;el.hidden=!choice.dataset.compare;});
    document.querySelectorAll('[data-tablet-saving]').forEach(el=>{el.textContent=choice.dataset.saving;el.hidden=!choice.dataset.saving;});
    this.sticky.querySelector('[data-bundle-summary]').textContent=choice.dataset.title+' · '+choice.dataset.price;
  }
  disconnectedCallback(){this.abortController?.abort();this.observer?.disconnect();this.sticky?.remove();this.initialized=false;}
});
  } catch(e) { console.error(e); }
})();

})();
